<template>
  <div>
    <el-row class="container" style="margin-top:15px;" :gutter="20">
      <!-- Columna Filtros -->
      <el-col class="container_col_1" :span="6">
        <!-- Header filtros-->
        <el-row style="margin-bottom:15px;">
          <el-col :span="16">
            <div class="title">{{ $t('NAVBAR_reg_instalacion') }}</div>
          </el-col>
          <el-col :span="8" class="btn-nuevo">
            <router-link class="btn-nuevo" :to="{ name: 'Registrar Garantia'}">
              <el-button type="primary" icon="el-icon-plus" size="medium" round>{{ $t('GENERAL_nuevo') }}</el-button>
            </router-link>
          </el-col>
        </el-row>
        <!-- Filtros -->
        <el-row>
          <el-collapse v-model="activeNames" style="margin-bottom: 5px;">
            <el-collapse-item :title="$t('GENERAL_Busqueda')" name="0">
              <div class="filters">
                <div class="filters_item">
                  <!-- <div class="label">{{ $t('GARANTIAS_ns') }}</div> -->
                  <NumeroSerieInput
                    :name="'nro_serie'"
                    :label="this.$t('GARANTIAS_ns')"
                    :value="filtros.ns"
                    :onChange="this.onNumeroSerieChange"
                    :readonly="false"
                    :customClases="'nro_serie gridItem'"
                    @ocultar="validar"
                  />
                  <!-- <el-input
                    :placeholder="$t('GARANTIAS_ns')"
                    size="small"
                    v-model="filtros.ns"
                    @input="getGarantiasDelayed"
                  /> -->
                </div>
                <div class="filters_item">
                  <div class="label">{{$t('GARANTIAS_tiene_patente')}}</div>
                  <el-input
                    :placeholder="$t('GARANTIAS_nro_patente')"
                    size="small"
                    v-model="filtros.patente"
                    @input="getGarantiasDelayed"
                  />
                </div>
                <div class="filters_item">
                  <div class="label">{{$t('GARANTIAS_usuario')}}</div>
                  <el-input
                    :placeholder="$t('GARANTIAS_usuario')"
                    size="small"
                    v-model="filtros.usuario"
                    @input="getGarantiasDelayed"
                  />
                </div>

                <div class="label">
                  {{$t('GARANTIAS_incl_prod_asoc')}}
                  <el-switch
                    class="switch"
                    v-model="filtros.incluirAsociados"
                    size="small"
                    @input="getGarantiasDelayed"
                  />
                </div>

              <div class="clearFilters" @click="cleanFilters">{{$t('GENERAL_clean_filters')}}</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </el-col>

      <!-- Resultados de búsqueda --> 
      <el-col class="container_col_2" :span="17">
        <!-- Header resultados de búsqueda -->
        <el-row style="margin-bottom:15px;">
          <el-col :xs="8" :sm="12"  :md="10" :lg="16" :xl="16">
             <div class="sub-title">{{$t('GENERAL_resultado')}}</div>
          </el-col>
          <el-col :xs="16" :sm="12"  :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination         
            background
            small
            layout="prev, pager, next"
            :current-page="paginador.page"
            :page-count="paginador.nro_pages"
            :page-size="paginador.pageSize"
            @current-change="handlePageChange"
            :pager-count="5"
            hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>
        <!-- Garantias -->
        <el-row>
          <div class="card_list">
            <div v-if="loading" v-loading.lock="loading" class="loader"></div>
            <div v-else-if="garantias !== undefined && garantias.length > 0"
                class="card_list_item"
                v-for="garantia in garantias"
                :key="garantia.Ns">
                <GarantiaCard :garantia="garantia" />
            </div>
            <div v-else class="loader">{{$t('GENERAL_no_data')}}</div>
          </div>
        </el-row>
        
      </el-col>
    </el-row>
    <!-- Paginador abajo -->
    <el-row style="margin-top:10px; margin-right:20px; text-align: right;">
      <el-col :span="23">
        <!-- <el-button type="primary" icon="el-icon-plus" size="small" round @click="topFunction">
          Arriba
        </el-button> -->
        <el-pagination         
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              :pager-count="5"              
              @current-change="handlePageChange"
              hide-on-single-page 
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import GarantiaCard from "@/components/Cards/garantiaCard";
import NumeroSerieInput from "../NumeroSerieInput";
import { mapState } from "vuex";

let defaultPaginador = {
  page: 1,
  nro_pages: 1,
  pageSize: 20
};

let defaultFilters = {
  ns: "",
  usuario: "",
  patente: "",
  incluirAsociados: false
};

export default {
  name: "Garantias",
  components: { GarantiaCard, NumeroSerieInput},
  data() {
    return {
      garantias: undefined,
      paginador: { ...defaultPaginador },
      filtros: { ...defaultFilters },
      activeNames: ["1"],
      loading: false,
      esNS: false,
      nro_serie: '',
    };
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      ultimoFiltroAplicado: state => state.garantias.filtrosGarantia
    })
  },
  methods: {
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    handlePageChange(page) {
      this.paginador.page = page;
      this.getGarantias();
    },
    getGarantias() {
       // armo el payload
      let payload = { ...this.filtros };

      (payload.idUsuario = this.idUsuario);
      (payload.page = this.paginador.page),
      (payload.pageSize = this.paginador.pageSize);
        

      // guardo los últimos filtros aplicados
      this.$store.dispatch("garantias/setFiltrosGarantia", { ...payload });



      // No se busca hasta que no se ingresa un filtro
      if (
        this.filtros.ns == "" &&
        this.filtros.patente == "" &&
        this.filtros.usuario == "" &&
        this.filtros.incluirAsociados == false
      ){
        this.garantias = [];
        return;
      }

      // indico que se están buscando las garantías
      this.loading = true;

      // busco las garantías
      this.$store
        .dispatch("garantias/getGarantias", payload)
        .then(data => {
          this.garantias = data.Datos ? data.Datos.Garantias : [];
          this.paginador.nro_pages = data.Datos ? data.Datos.TotalPaginas : 0;

        })
        .finally(() => (this.loading = false));
    },
    getGarantiasDelayed(){

      if(this.esNS){
        this.filtros.incluirAsociados =true;
      }
      else{
        this.filtros.incluirAsociados =false;
      }

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.paginador = { ...defaultPaginador };
        this.getGarantias();
      }, 1000);
    },
    onNumeroSerieChange(payload) {
      this.filtros.ns = payload.value;

      this.getGarantiasDelayed();
    },
    validar(esNs) {
      if (esNs == "S") this.esNS = true;
      else this.esNS = false;
    },
    cleanFilters() {
      // limpio los filtros
      this.filtros = { ...defaultFilters };
      this.paginador = { ...defaultPaginador };

      // limpio los resultados de garantía
      this.garantias = [];

      this.getGarantias();
    },
  },
  mounted() {
    // verifico si se deben mantener los últimos filtros aplicados
    if (this.$route.params.keepFilter === true){
      this.filtros = { ...this.ultimoFiltroAplicado };
      this.filtros.ns = this.$route.params.ns !== undefined? this.$route.params.ns : this.ultimoFiltroAplicado.ns}

    // busco las garantías
    this.getGarantias();
  },
  
};
</script>

<style scoped>

.btn-nuevo {
  padding-right:0%;
  text-align:right;
}
.el-card {
  height: 100%;
}
.container {
  display: flex;
  min-height: 500px !important;
  width:  100% !important;
}

.pagination_container {
  text-align: right;
  padding-right:0px;
}

@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 1;
    width:100% !important;
  }
  .container_col_2 {
    flex: 1;
    width:100% !important;
    margin-top:20px;
  }
}

.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
}
.card_list_item {
  position: relative;
}
.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.filters {
  display: flex;
  flex-direction: column;
}
.filters_item {
  flex: 1;
  margin-bottom: 10px;
}
.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}
.switch {
  margin-left: 10px;
  margin-bottom: 2px;
}
.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}
.el-card__body {
  padding: 20px 40px;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


.el-radio-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 14px;
}
.el-radio {
  line-height: 2;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.loader {
  margin-top: 25%;
  color: #999;
}
</style>
